import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "design-system/atoms/Accordion"
import { ReactNode } from "react"
import { useTranslation } from "react-i18next"

type Props = {
  activationSettings: ReactNode
}

export function CampaignActivationAccordion({ activationSettings }: Props) {
  const { t } = useTranslation()

  return (
    <Accordion type="single" collapsible className="border rounded-lg bg-secondary">
      <AccordionItem value="campaign-activation">
        <AccordionTrigger className="text-lg">
          {t("capabilities.activation.sectionLabel")}
        </AccordionTrigger>
        <AccordionContent>{activationSettings}</AccordionContent>
      </AccordionItem>
    </Accordion>
  )
}
